import { FC } from 'react';
import {
  TextLink,
  TextLinkStyle,
  CardRadioButton,
  MLPVersion,
  Theme,
  useTranslation,
} from '@nextgen-web-framework/all';
import styles from './ShopOptionRadioCard.module.scss';
import { IShopsOptions, IShopOptionRadioCardProps } from './types/propsTypes';

export const ShopOptionRadioCard: FC<IShopOptionRadioCardProps> = ({
  cardData,
  isSelected,
  setSelectedShop,
  distance = '',
  shopDetails,
}: IShopOptionRadioCardProps) => {
  const t = useTranslation();

  const onSelectCard = (cardData: IShopsOptions) => {
    if (cardData?.id && cardData?.serviceLocation) {
      setSelectedShop(cardData?.id);
    }
  };

  return (
    <div className={styles['shop-option-card-wrapper']}>
      <CardRadioButton
        mlpVersion={MLPVersion.ONE}
        label={
          <div className={styles['shop-option-card-label-container']}>
            <span className={`${isSelected && styles['shop-option-card-name']}`}>{cardData?.name}</span>
            <span className={styles['shop-option-card-store-id-hide']}>
              {cardData?.id && <span className={styles['shop-option-card-label-separator']}></span>}
              <span className={`${isSelected && styles['shop-option-card-storeId']}`}>{cardData?.id}</span>
            </span>
          </div>
        }
        checked={isSelected}
        onChange={() => onSelectCard(cardData)}
        className={
          isSelected
            ? `${styles['shop-option-radio-card']} ${styles['selected']}`
            : `${styles['shop-option-radio-card']}`
        }
        theme={isSelected ? Theme.PURPLE : Theme.BLACK}
      >
        <div className={styles['shop-card-children-container']}>
          <p>
            <span className={styles['shop-address-line']}>{cardData?.addressLine}</span>
          </p>
          <p className={styles['shop-card-footer']}>
            <span>
              <TextLink
                id={styles['store-details']}
                data-testid="store-details"
                text={t('web.ShopFinder.shopDetails')}
                onClick={() => shopDetails(cardData)}
                textLinkStyle={TextLinkStyle.UNDERLINE}
                theme={Theme.PURPLE}
                scroll={false}
              />
            </span>
            <span className={styles['shop-distance']}>{distance}</span>
          </p>
        </div>
      </CardRadioButton>
    </div>
  );
};

export default ShopOptionRadioCard;
